import { useState } from 'react';
import AnalyticsCard from './AnalyticsCard';

const SORTS = [
  { key: 'total',     label: 'Total' },
  { key: 'completed', label: 'Completed' },
  { key: 'failed',    label: 'Failed' },
  { key: 'rate',      label: 'Success Rate' },
];

export default function UserPerformance({ data }) {
  const [sortBy, setSortBy] = useState('total');
  const sorted = [...data].sort((a, b) => b[sortBy] - a[sortBy]);

  return (
    <AnalyticsCard title="User Performance (Top 20 by volume)">
      <div className="flex gap-2 mb-4 flex-wrap">
        {SORTS.map((o) => (
          <button
            key={o.key}
            onClick={() => setSortBy(o.key)}
            className={`text-xs px-3 py-1 rounded-full font-medium transition-colors ${
              sortBy === o.key
                ? 'bg-primary text-white'
                : 'bg-background-primary text-text-secondary hover:bg-background-hover'
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border-primary">
              {['#', 'User', 'Total', 'Completed', 'Failed', 'Success Rate'].map((h) => (
                <th key={h} className="text-left text-xs text-text-secondary font-medium pb-2 pr-4 last:pr-0">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.map((u, i) => (
              <tr key={u.email} className="border-b border-border-primary hover:bg-background-hover transition-colors">
                <td className="py-2 pr-4 text-xs text-text-secondary">{i + 1}</td>
                <td className="py-2 pr-4">
                  <p className="text-xs font-medium text-text-primary">{u.user}</p>
                  <p className="text-[10px] text-text-secondary truncate max-w-[180px]">{u.email}</p>
                </td>
                <td className="py-2 pr-4 text-xs font-semibold text-text-primary">{u.total.toLocaleString()}</td>
                <td className="py-2 pr-4 text-xs font-medium" style={{ color: '#10b981' }}>{u.completed.toLocaleString()}</td>
                <td className="py-2 pr-4 text-xs font-medium" style={{ color: '#ef4444' }}>{u.failed.toLocaleString()}</td>
                <td className="py-2">
                  <div className="flex items-center gap-2">
                    <div className="flex-1 h-1.5 bg-background-primary rounded-full overflow-hidden min-w-[60px]">
                      <div
                        className="h-full rounded-full"
                        style={{
                          width: `${u.rate}%`,
                          background: u.rate >= 70 ? '#10b981' : u.rate >= 40 ? '#f97316' : '#ef4444',
                        }}
                      />
                    </div>
                    <span
                      className="text-xs font-semibold w-10 text-right"
                      style={{ color: u.rate >= 70 ? '#10b981' : u.rate >= 40 ? '#f97316' : '#ef4444' }}
                    >
                      {u.rate}%
                    </span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AnalyticsCard>
  );
}
